@if (!studentUuid()) {
	<nz-empty nzNotFoundContent="Select a student to see their activities."></nz-empty>
} @else {
	<nz-table
		#activityTable
		[nzData]="activities()"
		[nzLoading]="loading()"
		[nzFrontPagination]="false"
		[nzTotal]="totalCount()"
		[nzPageSize]="PAGE_SIZE"
		[nzPageIndex]="page()"
		(nzPageIndexChange)="onPageChange($event)"
		nzNoResult="No activities have been logged for this student yet."
	>
		<thead>
			<tr>
				<th>Newest Activity</th>
				<th>Skill</th>
				<th>Take #</th>
				<th>Steps</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			@for (activity of activities(); track activity.activityUuid + '-' + activity.take) {
				<tr [class.selected]="isSelected(activity)" (click)="select(activity)">
					<td>{{ activity.latestLogAt | date: 'MMM d, y h:mm a' }}</td>
					<td>{{ activity.skillCode }}</td>
					<td>{{ activity.take }}</td>
					<td>{{ activity.stepCount }}</td>
					<td>
						<button nz-button nzType="link" nzSize="small" (click)="select(activity)">
							{{ isSelected(activity) ? 'Viewing' : 'View' }}
						</button>
					</td>
				</tr>
			}
		</tbody>
	</nz-table>
}
